"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.avatarStyles = exports.Avatar = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const Avatar = ({ imageUri }) => {
    return react_1.default.createElement(react_native_1.Image, { style: exports.avatarStyles.avatarImage, source: { uri: imageUri } });
};
exports.Avatar = Avatar;
exports.avatarStyles = react_native_1.StyleSheet.create({
    avatarImage: {
        borderRadius: 25,
        height: 50,
        width: 50,
    },
});
